module.exports = __webpack_public_path__ + "static/media/Premiere Pro.d90cc954.svg";